export const GET_BOOKING = "GET_BOOKING";
export const ADD_BOOKING = "ADD_BOOKING";
 
export const UPDATE_BOOKING_STATUS = "UPDATE_BOOKING_STATUS";
export const UPDATE_BOOKING_STATUS_SUCCESS = "UPDATE_BOOKING_STATUS_SUCCESS";
export const UPDATE_BOOKING_STATUS_FAILURE = "UPDATE_BOOKING_STATUS_FAILURE";

export const CANCEL_BOOKING = "CANCEL_BOOKING";
export const CANCEL_BOOKING_SUCCESS = "CANCEL_BOOKING_SUCCESS";
export const CANCEL_BOOKING_FAILURE = "CANCEL_BOOKING_FAILURE";

export const GET_BOOKING_CALCULATE = "GET_BOOKING_CALCULATE";
export const GET_BOOKING_STATUS = "GET_BOOKING_STATUS";
export const GET_BOOKING_SUCCESS = "GET_BOOKING_SUCCESS";

export const GET_ALL_BOOKING = "GET_ALL_BOOKING";
export const GET_ALL_BOOKING_SUCCESS = "GET_ALL_BOOKING_SUCCESS";

export const GET_ACTIVE_BOOKING = "GET_ACTIVE_BOOKING";
export const GET_ACTIVE_BOOKING_SUCCESS = "GET_ACTIVE_BOOKING_SUCCESS";

export const GET_PENDING_BOOKING = "GET_PENDING_BOOKING";
export const GET_PENDING_BOOKING_SUCCESS = "GET_PENDING_BOOKING_SUCCESS";

export const GET_BOOKING_CALCULATE_SUCCESS = "GET_BOOKING_CALCULATE_SUCCESS";
export const GET_BOOKING_CALCULATE_FAILURE = "GET_BOOKING_CALCULATE_FAILURE";

export const GET_ACTIVE_BOOKING_TYPES = "GET_ACTIVE_BOOKING_TYPES";
export const GET_ACTIVE_BOOKING_TYPES_SUCCESS =
  "GET_ACTIVE_BOOKING_TYPES_SUCCESS";
export const GET_ACTIVE_BOOKING_TYPES_FAILURE =
  "GET_ACTIVE_BOOKING_TYPES_FAILURE";

export const UPLOAD_BOOKING_LICENSE = "UPLOAD_BOOKING_LICENSE";
export const UPLOAD_BOOKING_LICENSE_SUCCESS = "UPLOAD_BOOKING_LICENSE_SUCCESS";
export const UPLOAD_BOOKING_LICENSE_FAILURE = "UPLOAD_BOOKING_LICENSE_FAILURE";

export const UPLOAD_BOOKING_AGREEMENT = "UPLOAD_BOOKING_AGREEMENT";
export const UPLOAD_BOOKING_AGREEMENT_SUCCESS =
  "UPLOAD_BOOKING_AGREEMENT_SUCCESS";
export const UPLOAD_BOOKING_AGREEMENT_FAILURE =
  "UPLOAD_BOOKING_AGREEMENT_FAILURE";

export const UPLOAD_BOOKING_SELFIE_WITH_CAR = "UPLOAD_BOOKING_SELFIE_WITH_CAR";
export const UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS =
  "UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS";
export const UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE =
  "UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE";

export const UPLOAD_BOOKING_ADDRESS_PROOF = "UPLOAD_BOOKING_ADDRESS_PROOF";
export const UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS =
  "UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS";
export const UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE =
  "UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE";

export const BOOKING_SUCCESS = "BOOKING_SUCCESS";
export const BOOKING_FAILURE = "BOOKING_FAILURE";

export const GET_BOOKING_DATES = "GET_BOOKING_DATES";
export const GET_BOOKING_DATES_SUCCESS = "GET_BOOKING_DATES_SUCCESS";
export const GET_BOOKING_DATES_FAILURE = "GET_BOOKING_DATES_FAILURE";

export const GET_FINAL_AGREEMENT_CHECKLIST = "GET_FINAL_AGREEMENT_CHECKLIST";
export const GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS =
  "GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS";
export const GET_FINAL_AGREEMENT_CHECKLIST_FAILURE =
  "GET_FINAL_AGREEMENT_CHECKLIST_FAILURE";

export const GET_CHECKIN_IMAGE = "GET_CHECKIN_IMAGE";
export const GET_CHECKIN_IMAGE_SUCCESS = "GET_CHECKIN_IMAGE_SUCCESS";
export const GET_CHECKIN_IMAGE_FAILURE = "GET_CHECKIN_IMAGE_FAILURE";

export const UPLOAD_CHECKIN_IMAGE = "UPLOAD_CHECKIN_IMAGE";
export const UPLOAD_CHECKIN_IMAGE_SUCCESS = "UPLOAD_CHECKIN_IMAGE_SUCCESS";
export const UPLOAD_CHECKIN_IMAGE_FAILURE = "UPLOAD_CHECKIN_IMAGE_FAILURE";

export const GET_PROGRESS_MESSAGES = "GET_PROGRESS_MESSAGES";
export const GET_PROGRESS_MESSAGES_SUCCESS = "GET_PROGRESS_MESSAGES_SUCCESS";
export const GET_PROGRESS_MESSAGES_FAILURE = "GET_PROGRESS_MESSAGES_FAILURE";

export const CREATE_EXTENSION_REQUEST = "CREATE_EXTENSION_REQUEST";
export const CREATE_EXTENSION_REQUEST_SUCCESS = "CREATE_EXTENSION_REQUEST_SUCCESS";
export const CREATE_EXTENSION_REQUEST_FAILURE = "CREATE_EXTENSION_REQUEST_FAILURE";

export const RESET_BOOKING_STATE = "RESET_BOOKING_STATE";

export interface BookingState {
  bookings: any;
  activeBookings: any;
  bookingDetail: any;
  bookingTotalAmount: any;
  bookingStatusList: any;
  bookingsSuccess: string | null;
  bookingDetailLoading: boolean;
  bookingsError: string | null;
  bookingsLoading: boolean;
  bookingTypes: any;
  bookingsCalculateError: string | null;

  bookingUploadLicenseLoading: boolean;
  bookingUploadLicenseSuccess: string | null;
  bookingUploadLicenseError: string | null;

  bookingUploadAgreementLoading: boolean;
  bookingUploadAgreementSuccess: string | null;
  bookingUploadAgreementError: string | null;

  bookingDates: any;
  bookingDatesLoading: boolean;
  bookingDatesSuccess: string | null;
  bookingDatesError: string | null;

  pendingBookings: any;
  pendingBookingsLoading: boolean;
  pendingBookingsSuccess: string | null;
  pendingBookingsError: string | null;

  bookingSelfieWithCarLoading: boolean;
  bookingSelfieWithCarSuccess: string | null;
  bookingSelfieWithCarError: string | null;
  bookingCancelSuccess: string | null;

  bookingAddressProofLoading: boolean;
  bookingAddressProofSuccess: string | null;
  bookingAddressProofError: string | null;
  bookingCancelLoading: boolean;
  finalAgreementChecklist: any;


  checkInCarImages: any;

  checkInCarImagesSuccess: string | null;
  checkInCarImagesError: string | null;
  checkInCarImagesLoading: boolean;
 bookingCancelError: string | null;
  progressMessages: any;

  extensionRequestLoading: boolean;
  extensionRequestSuccess: string | null;
  extensionRequestError: string | null;
  extensionRequest: any;

}

interface GetAllBookingAction {
  type: typeof GET_ALL_BOOKING;
  payload: any;
}

interface GetAllBookingSucess {
  type: typeof GET_ALL_BOOKING_SUCCESS;
  payload: any;
}

interface GetActiveBooking {
  type: typeof GET_ACTIVE_BOOKING;
  payload: any;
}

interface GetActiveBookingSucess {
  type: typeof GET_ACTIVE_BOOKING_SUCCESS;
  payload: any;
}

interface GetPendingBooking {
  type: typeof GET_PENDING_BOOKING;
  payload: any;
}

interface GetPendingBookingSucess {
  type: typeof GET_PENDING_BOOKING_SUCCESS;
  payload: any;
}

interface GetBookingAction {
  type: typeof GET_BOOKING;
  payload: any;
}

interface GetBookingCalculate {
  type: typeof GET_BOOKING_CALCULATE;
  payload: any;
}

interface GetBookingCalculateSucess {
  type: typeof GET_BOOKING_CALCULATE_SUCCESS;
  payload: any;
}

interface GetBookingCalculateFailure {
  type: typeof GET_BOOKING_CALCULATE_FAILURE;
  payload: any;
}

interface GetBookingStatusAction {
  type: typeof GET_BOOKING_STATUS;
  payload: any;
}

interface GetBookingSucess {
  type: typeof GET_BOOKING_SUCCESS;
  payload: any;
}

interface AddBookingAction {
  type: typeof ADD_BOOKING;
  payload: any;
}

interface BookingSucess {
  type: typeof BOOKING_SUCCESS;
  payload: any;
}

interface BookingFailure {
  type: typeof BOOKING_FAILURE;
  payload: string;
}

interface UpdateBookingStatus {
    type: typeof UPDATE_BOOKING_STATUS;
    payload: any;
}

interface UpdateBookingStatusSucess {
    type: typeof UPDATE_BOOKING_STATUS_SUCCESS;
    payload: any;
}

interface UpdateBookingStatusFailure {
    type: typeof UPDATE_BOOKING_STATUS_FAILURE;
    payload: string;
}


interface CancelBooking {
    type: typeof CANCEL_BOOKING;
    payload: any;
}

interface CancelBookingSucess {
    type: typeof CANCEL_BOOKING_SUCCESS;
    payload: any;
}


interface CancelBookingFailure {
    type: typeof CANCEL_BOOKING_FAILURE;
    payload: string;
}



interface GetActiveBookingTypesAction {
  type: typeof GET_ACTIVE_BOOKING_TYPES;
  payload: any;
}

interface GetActiveBookingTypesSucess {
  type: typeof GET_ACTIVE_BOOKING_TYPES_SUCCESS;
  payload: any;
}

interface GetActiveBookingTypesFailure {
  type: typeof GET_ACTIVE_BOOKING_TYPES_FAILURE;
  payload: string;
}

interface UploadBookingLicense {
  type: typeof UPLOAD_BOOKING_LICENSE;
  payload: any;
}

interface UploadBookingLicenseSucess {
  type: typeof UPLOAD_BOOKING_LICENSE_SUCCESS;
  payload: any;
}

interface UploadBookingLicenseFailure {
  type: typeof UPLOAD_BOOKING_LICENSE_FAILURE;
  payload: string;
}

interface UploadBookingAgreement {
  type: typeof UPLOAD_BOOKING_AGREEMENT;
  payload: any;
}

interface UploadBookingAgreementSucess {
  type: typeof UPLOAD_BOOKING_AGREEMENT_SUCCESS;
  payload: any;
}

interface UploadBookingAgreementFailure {
  type: typeof UPLOAD_BOOKING_AGREEMENT_FAILURE;
  payload: string;
}

interface GetBookingDates {
  type: typeof GET_BOOKING_DATES;
  payload: any;
}

interface GetBookingDatesSucess {
  type: typeof GET_BOOKING_DATES_SUCCESS;
  payload: any;
}

interface GetBookingDatesFailure {
  type: typeof GET_BOOKING_DATES_FAILURE;
}

interface UploadBookingSelfieWithCar {
  type: typeof UPLOAD_BOOKING_SELFIE_WITH_CAR;
  payload: any;
}

interface UploadBookingSelfieWithCarSucess {
  type: typeof UPLOAD_BOOKING_SELFIE_WITH_CAR_SUCCESS;
  payload: any;
}

interface UploadBookingSelfieWithCarFailure {
  type: typeof UPLOAD_BOOKING_SELFIE_WITH_CAR_FAILURE;
  payload: any;
}

interface UploadBookingAddressProof {
  type: typeof UPLOAD_BOOKING_ADDRESS_PROOF;
  payload: any;
}

interface UploadBookingAddressProofSucess {
  type: typeof UPLOAD_BOOKING_ADDRESS_PROOF_SUCCESS;
  payload: any;
}

interface UploadBookingAddressProofFailure {
  type: typeof UPLOAD_BOOKING_ADDRESS_PROOF_FAILURE;
  payload: string;
}

//aa

interface FinalAgreementChecklist {
  type: typeof GET_FINAL_AGREEMENT_CHECKLIST;
  payload: any;
}

interface FinalAgreementChecklistSucess {
  type: typeof GET_FINAL_AGREEMENT_CHECKLIST_SUCCESS;
  payload: any;
}

interface FinalAgreementChecklistFailure {
  type: typeof GET_FINAL_AGREEMENT_CHECKLIST_FAILURE;
  payload: string;
}



interface GetCheckInImage {
  type: typeof GET_CHECKIN_IMAGE;
  payload: any;
}

interface GetCheckInImageSucess {
  type: typeof GET_CHECKIN_IMAGE_SUCCESS;
  payload: any;
}

interface GetCheckInImageFailure {
  type: typeof GET_CHECKIN_IMAGE_FAILURE;
  payload: string;
}



interface UplaodCheckInImage {
  type: typeof UPLOAD_CHECKIN_IMAGE;
  payload: any;
}

interface UplaodCheckInImageSucess {
  type: typeof UPLOAD_CHECKIN_IMAGE_SUCCESS;
  payload: any;
}

interface UplaodCheckInImageFailure {
  type: typeof UPLOAD_CHECKIN_IMAGE_FAILURE;
  payload: string;
}


interface GetProgressMessges {
  type: typeof GET_PROGRESS_MESSAGES;
  payload: any;
}

interface GetProgressMessgesSucess {
  type: typeof GET_PROGRESS_MESSAGES_SUCCESS;
  payload: any;
}

interface GetProgressMessgesFailure {
  type: typeof GET_PROGRESS_MESSAGES_FAILURE;
  payload: string;
}

interface ResetBookingAction {
  type: typeof RESET_BOOKING_STATE;
}

interface CreateExtensionRequestAction {
  type: typeof CREATE_EXTENSION_REQUEST;
  payload: any;
}

interface CreateExtensionRequestSuccess {
  type: typeof CREATE_EXTENSION_REQUEST_SUCCESS;
  payload: any;
}

interface CreateExtensionRequestFailure {
  type: typeof CREATE_EXTENSION_REQUEST_FAILURE;
  payload: string;
}

export type BookingActionTypes =
  | GetActiveBookingTypesAction
  | GetActiveBookingTypesSucess
  | GetActiveBookingTypesFailure
  | BookingSucess
  | BookingFailure
  | GetBookingAction
  | GetAllBookingAction
  | GetAllBookingSucess
  | GetBookingSucess
  | GetBookingStatusAction
  | GetBookingCalculate
  | GetBookingCalculateSucess
  | GetBookingCalculateFailure
  | UpdateBookingStatus
  | UpdateBookingStatusSucess
  | UpdateBookingStatusFailure
  | AddBookingAction
  | UploadBookingLicense
  | UploadBookingLicenseSucess
  | UploadBookingLicenseFailure
  | UploadBookingAgreement
  | UploadBookingAgreementSucess
  | UploadBookingAgreementFailure
  | GetActiveBooking
  | GetActiveBookingSucess
  | GetPendingBooking
  | GetPendingBookingSucess
  | GetBookingDates
  | GetBookingDatesSucess
  | GetBookingDatesFailure
  | UploadBookingSelfieWithCar
  | UploadBookingSelfieWithCarSucess
  | UploadBookingSelfieWithCarFailure
  | UploadBookingAddressProof
  | UploadBookingAddressProofSucess
  | UploadBookingAddressProofFailure
  | AddBookingAction
  | FinalAgreementChecklist
  | FinalAgreementChecklistSucess
  | FinalAgreementChecklistFailure
  | UplaodCheckInImage
  | UplaodCheckInImageSucess
  | UplaodCheckInImageFailure

  | GetCheckInImage
  | GetCheckInImageSucess
  | GetCheckInImageFailure

  | GetProgressMessges
  | GetProgressMessgesSucess
  | GetProgressMessgesFailure

  | UpdateBookingStatus | UpdateBookingStatusSucess | UpdateBookingStatusFailure
    | CancelBooking | CancelBookingSucess | CancelBookingFailure | AddBookingAction

    | CreateExtensionRequestAction
  | CreateExtensionRequestSuccess
  | CreateExtensionRequestFailure
  
  | ResetBookingAction;
